<div class="party" id="partij_{{ role | lowercase }}">
    <div class="party__title">
        <div class="party__title-inner">
            <h4 *ngIf="role === partyRoles.Witness ">Getuigen</h4>
            <h4 *ngIf="role === partyRoles.Driver ">Bestuurder</h4>
            <h4 *ngIf="role === partyRoles.Contact ">Afwijkende contactpersoon</h4>
            <h4 *ngIf="role === partyRoles.CoInsured ">Medeverzekerde</h4>
            <h4 *ngIf="role === partyRoles.CounterParty ">Tegenpartij</h4>

            <div *ngIf="allowAdd" class="party__button">
                <button (click)="toggle()" aria-label="Partij toevoegen" class="btn btn--icon">
                    <svg class="svg-icon svg-icon--s">
                        <use href="assets/icons-ui.svg#toevoegen"></use>
                    </svg>
                </button>
            </div>
        </div>
    </div>

    <div *ngIf="persons.length < 1" class="party__overview">
        <p class="party__information" *ngIf="role === partyRoles.Witness ">U heeft nog geen getuigen opgegeven</p>
        <p class="party__information" *ngIf="role === partyRoles.Driver ">U heeft nog geen bestuurder opgegeven</p>
        <p class="party__information" *ngIf="role === partyRoles.Contact ">U heeft nog geen afwijkende contactpersoon opgegeven</p>
        <p class="party__information" *ngIf="role === partyRoles.CoInsured ">U heeft nog geen medeverzekerde opgegeven</p>
        <p class="party__information" *ngIf="role === partyRoles.CounterParty ">U heeft nog geen tegenpartij opgegeven</p>
    </div>

    <ng-container *ngIf="persons.length > 0">
        <div *ngFor="let persoon of persons" class="party__overview">
            <p *ngIf="persoon.volledige_naam || persoon.handelsnaam">
                <span *ngIf="persoon.volledige_naam">{{ persoon.volledige_naam }}</span>
                <span *ngIf="persoon.handelsnaam">{{ persoon.handelsnaam }}</span>
                <span
                    *ngIf="role === partyRoles.CounterParty && persoon.persoon_type === 'NNP'
                    && persoon.rol.tegenpartij && persoon.rol.tegenpartij.bestuurder"
                    class="float-right"
                >
                    Bestuurder:
                    {{ persoon.rol.tegenpartij.bestuurder.voorletters }}
                    {{ persoon.rol.tegenpartij.bestuurder.tussenvoegsels }}
                    {{ persoon.rol.tegenpartij.bestuurder.achternaam }}
                </span>
            </p>
        </div>
    </ng-container>

    <div *ngIf="addDriver" class="party__toevoegen">
        <ins-add-party-container
            (closed)="toggleDriver()"
            *ngIf="showContent"
            [addressRelationId]="addressRelationId"
            [counterPartySerialNumber]="counterPartySerialNumber"
            [fileSerialNumber]="fileSerialNumber"
            [isCompanyDriver]="true"
            [relationId]="relationId"
            [role]="role"
        ></ins-add-party-container>
    </div>

</div>
